import styled from "styled-components";
import { ExternalLink } from "./ExternalLink";
import { greyColor } from "./colors";
import React from "react";
import { Link } from "react-router-dom";

export const FooterLink = makeFooterLink(Link);

export const FooterExternalLink = makeFooterLink(ExternalLink);

function makeFooterLink<P>(
  component: React.ComponentType<P>,
) {
  return styled(component)`
    font-size: 12px;
    color: ${greyColor};
    text-decoration: none;

    :hover {
      text-decoration: underline;
    }
  `;
}
